import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { LocalStorage } from '../local-storage/local-storage.service';
import { environment } from '../../../../environments/environment';
import { ThemeEnum } from './models/enums/theme.enum';

/**
 * Controla o tema da aplicação. O tema escuro é o padrão; o claro é aplicado com a classe `light` no `<html>`,
 * que troca os tokens definidos em src/themes/_tokens.scss
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(
    private readonly localStorage: LocalStorage,
  ) { }

  private readonly _theme: WritableSignal<ThemeEnum> = signal(ThemeEnum.DARK);

  public get theme(): Signal<ThemeEnum> {
    return this._theme;
  }

  public set theme(theme: ThemeEnum) {
    this.localStorage.setItem(environment.keys.theme, theme);
    this._theme.set(theme);

    this.loadTheme(theme);
  }

  public initialize(): void {
    const stored = this.localStorage.getItem<ThemeEnum>(environment.keys.theme);
    const theme = stored === ThemeEnum.LIGHT ? ThemeEnum.LIGHT : ThemeEnum.DARK;

    this._theme.set(theme);
    this.loadTheme(theme);
  }

  public toggle(): void {
    this.theme = this._theme() === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
  }

  private loadTheme(theme: ThemeEnum): void {
    const isLight = theme === ThemeEnum.LIGHT;

    // Só a classe `light` é usada: o escuro é o visual base e a classe `dark` ativaria variantes `dark:` antigas
    // do Tailwind que não fazem parte do tema. O PrimeNG não é reconfigurado aqui: `primeNg.theme.set` injeta os
    // estilos padrão dos componentes por cima dos de src/styles.scss e eles não saem ao voltar para o escuro
    document.documentElement.classList.toggle(ThemeEnum.LIGHT, isLight);
    document.body.classList.toggle(ThemeEnum.LIGHT, isLight);
  }

}
